module.exports = __webpack_public_path__ + "img/france.42103279.svg";